import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";
import LayoutPhone from "../views/layout/Layout-phone";

export const constantRouterMap = [
  {
    path: "/",
    component: Layout,
    name: "首页",
    redirect: "index",
    children: [
      {
        path: "index",
        name: "首页",
        component: () => import("@/views/website-index/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/introduction",
    component: Layout,
    name: "集团简介",
    redirect: "/introduction-page",
    children: [
      {
        path: "/introduction-page",
        name: "集团简介",
        component: () => import("@/views/website-introduction/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/culture",
    component: Layout,
    name: "公司文化",
    redirect: "/culture-index",
    children: [
      {
        path: "/culture-index",
        name: "公司文化",
        component: () => import("@/views/website-culture/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/news",
    component: Layout,
    name: "新闻动态",
    redirect: "/news-index",
    children: [
      {
        path: "/news-index",
        name: "新闻动态",
        component: () => import("@/views/website-news/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/jobs",
    component: Layout,
    name: "招贤纳士",
    redirect: "/jobs-index",
    children: [
      {
        path: "/jobs-index",
        name: "招贤纳士",
        component: () => import("@/views/website-jobs/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/messages",
    component: Layout,
    name: "客户留言",
    redirect: "/messages-index",
    children: [
      {
        path: "/messages-index",
        name: "客户留言",
        component: () => import("@/views/website-messages/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/products",
    component: Layout,
    name: "公司产品",
    redirect: "/products-index",
    children: [
      {
        path: "/products-index",
        name: "公司产品",
        component: () => import("@/views/website-products/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/jobs",
    component: Layout,
    name: "招贤纳士",
    redirect: "/jobs-index",
    children: [
      {
        path: "/jobs-index",
        name: "招贤纳士",
        component: () => import("@/views/website-jobs/index"),
        meta: {}
      }
    ]
  },
  {
    path: "/contact",
    component: Layout,
    name: "联系我们",
    redirect: "/contact-index",
    children: [
      {
        path: "/contact-index",
        name: "联系我们",
        component: () => import("@/views/website-contact/index"),
        meta: {}
      }
    ]
  }
];


export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      vm.$router.replace(from.path)
    })
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js